import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.createInquiry;
export const createInquirySelector = (state: RootState) => getState(state).data;
